<template>
  <div class="product-tabs">
    <ul class="product-tabs-header mb-7">
      <li
        v-for="({ title }, index) in tabs"
        :key="`${title}-${index}`"
        class="product-tabs-title ota-p18"
        :class="{ 'product-tabs-title-active': index === selectedTabIndex }"
        @click="title ? selectTab(index) : () => ({})"
      >
        <span v-text="title" />
      </li>
    </ul>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ProductTabs',
  data () {
    return {
      selectedTabIndex: 0,
      tabs: []
    }
  },
  mounted () {
    this.selectTab(0)
  },
  created () {
    this.tabs = this.$children
  },
  methods: {
    selectTab (i) {
      this.selectedTabIndex = i

      this.tabs.forEach((tab, index) => {
        tab.isActive = (index === i)
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-tabs {
  &-header {
    @apply flex w-full;
  }

  &-title {
    @apply text-gray-400 border-b border-gray-200 p-rem cursor-pointer;

    &:first-child {
      @apply pl-0;
    }

    &:last-child {
      @apply flex-1;
    }

    &-active {
      @apply text-gray-600 border-gray-600;
    }
  }
}
</style>
